import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { MenuItem } from 'primeng/api';

/** Cabeçalho da lista de grupos: breadcrumb, título com a linha de apoio, busca e "Novo grupo". */
@Component({
  selector: 'app-group-list-header',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './group-list-header.component.html',
  styleUrls: ['./group-list-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupListHeaderComponent {
  readonly query = input('');
  readonly canCreate = input(false);
  /** Some a busca enquanto não há grupo nenhum (estado vazio e erro). */
  readonly showSearch = input(true);
  readonly queryChange = output<string>();
  readonly create = output<void>();

  readonly home: MenuItem = { icon: 'pi pi-home', routerLink: '/dashboard/dashboard-management' };
  readonly breadcrumbs: MenuItem[] = [{ label: 'Gerenciamento' }, { label: 'Grupos de permissão' }];
}
